import { MAP_SCALES } from './constants';
import gsap from 'gsap';
import Table from './table/table';
import { Stage } from 'konva/lib/Stage';

export default class Controls {
	stage;
	private scales = MAP_SCALES;
	private currentScaleIndex = 1;
	private isAlreadyScaling = false;
	private tl = gsap.timeline();
	private boundingBox = {
		maxX: 100,
		minX: -100,
		maxY: 100,
		minY: -100,
		extra: 100,
	};
	// private currentScale = 1;


	private tables: Table[] | undefined;

	constructor(stage: Stage) {
		this.tables;
		this.stage = stage;
		// this.setScale(1);

		this.boundingBox = {
			maxX: 0,
			minX: 0,
			maxY: 0,
			minY: 0,
			extra: 100,
		};

		this.initBoundingBox();
	}

	initialize(tables: Table[]) {
		this.tables = tables;
	}

	scaling(e: any) {
		if (this.isAlreadyScaling) {
			return;
		}

		let deltaY = e.evt.deltaY;

		deltaY > 0 ? (deltaY = 1) : (deltaY = -1);
		this.currentScaleIndex += deltaY;

		if (this.currentScaleIndex > this.scales.length - 1) {
			this.currentScaleIndex = this.scales.length - 1;
			return;
		}
		if (this.currentScaleIndex < 0) {
			this.currentScaleIndex = 0;
			return;
		}

		// let scaleToFit = (this.boundingBox.maxX * 2) / window.innerWidth;
		// console.log(scaleToFit);
		let factor = this.scales[this.currentScaleIndex];
		
		// if(scaleToFit < factor){
		// 	factor = scaleToFit;
		// }

		// this.currentScale = factor;
		this.scaleTo(factor);
	}

	private initBoundingBox(): void {
		// const width = this.stage.width();
		// const height = this.stage.height();

		this.stage.on('dragmove', () => {
			// const {maxX, maxY, minX, minY} = this.boundingBox
			// const stageX = -this.stage.x();
			// const stageY = -this.stage.y();
			// console.log(this.stage.x(), this.stage.y());

			// if (stageX > (maxX - width) * this.currentScale) {
			// 	this.stage.x((-maxX + width) * this.currentScale);
			// 	console.log('maxX');
			// }
			// if (stageX < (minX) * this.currentScale) {
			// 	this.stage.x((-minX) * this.currentScale);
			// 	console.log('minX');
			// }
			// if (stageY > (maxY - height) * this.currentScale) {
			// 	this.stage.y((-maxY + height)  * this.currentScale);
			// 	console.log('maxY');
			// }
			// if (stageY < (minY) * this.currentScale) {
			// 	this.stage.y((-minY)  * this.currentScale);
			// 	console.log('minY');
			// }

			// console.log(this.boundingBox);
		});
	}

	getBoundingBox(): any {
		return this.boundingBox;
	}

	checkBoundings(x: number, y: number, rect: any) {
		// console.log(rect);
		const tableWidth = parseInt(rect.width); 
		const tableHeight = parseInt(rect.height); 
		const bbBox = this.boundingBox;

		const maxX = Math.max(x + tableWidth, bbBox.maxX);
		const minX = Math.min(x, bbBox.minX);
		const maxY = Math.max(y + tableHeight, bbBox.maxY);
		const minY = Math.min(y, bbBox.minY);
		
		if(maxX > bbBox.maxX){
			bbBox.maxX = maxX;
		}
		if(minX < bbBox.minX){
			bbBox.minX = minX;
		}

		if(maxY > bbBox.maxY){
			bbBox.maxY = maxY;
		}
		if(minY < bbBox.minY){
			bbBox.minY = minY;
		}

		// console.log(this.boundingBox);

	}

	setScale(factor: number) {
		const pos = this.computeScalePosition(factor);

		this.stage.scaleX(factor);
		this.stage.scaleY(factor);
		this.stage.x(pos.x);
		this.stage.y(pos.y);
	}

	scaleTo(factor: number) {
		const newPos = this.computeScalePosition(factor);

		this.tl.to(this.stage, {
			duration: 0.33,
			scaleX: factor,
			scaleY: factor,
			x: newPos.x,
			y: newPos.y,
			onStart: () => {
				this.isAlreadyScaling = true;
			},
			onComplete: () => {
				this.isAlreadyScaling = false;
			},
		});
	}

	private computeScalePosition (factor: number){
		const { stage } = this;
		const scaleX: any = stage.scale()?.x
		const oldScale = scaleX || 1;

		const center = {
			x: stage.width() / 2,
			y: stage.height() / 2,
		};

		const relatedTo = {
			x: (center.x - stage.x()) / oldScale,
			y: (center.y - stage.y()) / oldScale,
		};

		return {
			x: center.x - relatedTo.x * factor,
			y: center.y - relatedTo.y * factor,
		};
	}
}
